import React from 'react'

  export const ArrowDown =()=>{
    return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="arrow-down-to-line">
    <path id="Vector" d="M12 17V3M12 17L6 11M12 17L18 11M19 21H5" stroke="#4C4442" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>        
    )
  }

  export const ArrowUp =()=>{
    return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="arrow-up-from-line">
    <path id="Vector" d="M18 9L12 3M12 3L6 9M12 3V17M5 21H19" stroke="#4C4442" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>        
    )
  }